"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_client_notifier_js_1 = require("@synisys/idm-client-notifier-js");
var skynet_store_properties_api_1 = require("@synisys/skynet-store-properties-api");
var lodash_1 = require("lodash");
var empty_1 = require("rxjs/observable/empty");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var logging_1 = require("./logging");
var LOGGER = logging_1.createLogger('kb-reload.service');
var notifierService;
function notifierEventSourceServiceFactory(store) {
    if (!notifierService) {
        // TODO: temporary solution
        // tslint:disable-next-line:max-classes-per-file
        var applicationProperties = new (/** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.getBuildVersion = function () {
                throw new Error('Not Implemented');
            };
            class_1.prototype.getCategoryIconsPath = function () {
                throw new Error('Not Implemented');
            };
            class_1.prototype.getProperty = function () {
                return skynet_store_properties_api_1.getProperties(store)
                    .pipe(operators_1.switchMap(function (properties) {
                    if (lodash_1.get(properties, 'client-notifier-service-url')) {
                        return of_1.of(lodash_1.get(properties, 'client-notifier-service-url'));
                    }
                    else {
                        LOGGER.warn("Can't find url for client-notifier-service, " +
                            "wouldn't automatically fetch changes from kb-service");
                        return empty_1.empty();
                    }
                }), operators_1.first())
                    .toPromise();
            };
            class_1.prototype.getStaticResourcesUrl = function () {
                throw new Error('Not Implemented');
            };
            return class_1;
        }(idm_application_properties_service_client_js_1.ApplicationPropertiesService)))();
        notifierService = new idm_client_notifier_js_1.NotifierEventSourceService(applicationProperties);
    }
    return notifierService;
}
exports.notifierEventSourceServiceFactory = notifierEventSourceServiceFactory;
//# sourceMappingURL=client-notifier.service.js.map